export default "__VITE_ASSET__ee109eea__$_?nuxt_component=async&nuxt_component_name=SvgoClockNumbers__"